import {Inject, Injectable, Optional, PLATFORM_ID, TransferState} from '@angular/core';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import {Observable, of} from "rxjs";
import {ANONYMOUS_SSR_SESSION, TokenDataProviderService} from "./token-data-provider.service";
import {CurrentUserViewModel} from "../models/current-user.view-model";
import {UserApiModel} from '../../api/models/user.api-model';
import {catchError, take} from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class CurrentUserResolverService  {
  constructor(
    private ts: TokenDataProviderService,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    @Optional() private readonly transferState: TransferState | null,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CurrentUserViewModel> {
    if (isPlatformServer(this.platformId) && !this.ts.isLoggedInSSR()) {
      this.transferState?.set(ANONYMOUS_SSR_SESSION, true);
    }
    // Match the anonymous server DOM for the first browser render. The root's
    // afterNextRender callback then restores the browser session and the live user$.
    if (isPlatformBrowser(this.platformId) && this.transferState?.get(ANONYMOUS_SSR_SESSION, false)) {
      return of(new CurrentUserViewModel(new UserApiModel()));
    }
    return this.ts.currentUser.pipe(
      take(1),
      // A temporary API outage must not prevent bootstrap and the post-hydration retry.
      catchError(() => this.ts.user$.pipe(take(1))),
    );
  }
}
